import React from "react";
import partner1 from "../../assets/About/parter1.png";
import partner2 from "../../assets/About/partner2.png";
import partner3 from "../../assets/About/partner3.png";
import partner4 from "../../assets/About/partner4.png";
import partner5 from "../../assets/About/partner5.png";
// import "./PartnerScroll.css"; // Import CSS file for styling

const PartnerScroll = () => {
  return (
    <div className="partner-scroll-container">
      <div className="font-montserrat flex flex-col gap-2 justify-center items-center text-center">
        <h3 className="text-lg text-orange-500 " data-aos="fade-up">
          OUR PARTNERS
        </h3>
        <p className="lg:w-96 text-wrap" data-aos="fade-up">
          Our partners are the driving force behind our success, fostering
          innovation and collaboration at every step.
        </p>
      </div>
      <div className="partner-scroll" data-aos="fade-up">
        <img src={partner1} alt="partner1" />
        <img src={partner2} alt="partner2" />
        <img src={partner3} alt="partner3" />
        <img src={partner4} alt="partner4" />
        <img src={partner5} alt="partner5" />

        <img src={partner1} alt="partner1" />
        <img src={partner2} alt="partner2" />
        <img src={partner3} alt="partner3" />
        <img src={partner4} alt="partner4" />
        <img src={partner5} alt="partner5" />
        <img src={partner1} alt="partner1" />
        <img src={partner2} alt="partner2" />
        <img src={partner3} alt="partner3" />
        <img src={partner4} alt="partner4" />
        <img src={partner5} alt="partner5" />
        <img src={partner1} alt="partner1" />
        <img src={partner2} alt="partner2" />
        <img src={partner3} alt="partner3" />
        <img src={partner4} alt="partner4" />
        <img src={partner5} alt="partner5" />
        <img src={partner1} alt="partner1" />
        <img src={partner2} alt="partner2" />
        <img src={partner3} alt="partner3" />
        <img src={partner4} alt="partner4" />
        <img src={partner5} alt="partner5" />
        <img src={partner1} alt="partner1" />
        <img src={partner2} alt="partner2" />
        <img src={partner3} alt="partner3" />
        <img src={partner4} alt="partner4" />
        <img src={partner5} alt="partner5" />
        <img src={partner1} alt="partner1" />
        <img src={partner2} alt="partner2" />
        <img src={partner3} alt="partner3" />
        <img src={partner4} alt="partner4" />
        <img src={partner5} alt="partner5" />
        <img src={partner1} alt="partner1" />
        <img src={partner2} alt="partner2" />
        <img src={partner3} alt="partner3" />
        <img src={partner4} alt="partner4" />
        <img src={partner5} alt="partner5" />
        <img src={partner1} alt="partner1" />
        <img src={partner2} alt="partner2" />
        <img src={partner3} alt="partner3" />
        <img src={partner4} alt="partner4" />
        <img src={partner5} alt="partner5" />
        <img src={partner1} alt="partner1" />
        <img src={partner2} alt="partner2" />
        <img src={partner3} alt="partner3" />
        <img src={partner4} alt="partner4" />
        <img src={partner5} alt="partner5" />
        <img src={partner1} alt="partner1" />
        <img src={partner2} alt="partner2" />
        <img src={partner3} alt="partner3" />
        <img src={partner4} alt="partner4" />
        <img src={partner5} alt="partner5" />
      </div>
    </div>
  );
};

export default PartnerScroll;
